import styles from '../src/LandingPage.module.scss'

export const LandingPage = () => {
    return (
        <div className={styles.App}>
            <header className='App-header' style={{ textAlign: 'center' }}>
                <h1>AWC React</h1>
            </header>
            <div className={styles.menu} style={{ textAlign: 'center' }}>
                <ul>
                    <li>
                        <a href='/Dashboard/ARAging' target={'_blank'}>
                            ARAging dashboard
                        </a>
                    </li>
                    <li>
                        <a href='/dashboard/assemblysearch' target={'_blank'}>
                            Assembly Search
                        </a>
                    </li>

                    <li>
                        <a href='/categoryforms/'>Category Forms</a>
                    </li>
                    <li>
                        <a href='/import/commissions'>Commission Order Import</a>
                    </li>
                    <li>
                        <a href='/components'>Components</a>
                    </li>
                    <li>
                        <a href='/EDIFormsReact'>EDI Forms</a>
                    </li>
                    <li>
                        <a href='/FastQuote'>Fast Quote</a>
                    </li>
                    <li>
                        <a href='/lcmforms'>LCM Forms</a>
                    </li>
                    <li>
                        <a href='/PointOfSaleManager'>Point of Sale Manager</a>
                    </li>
                    <li>
                        <a href='/lcmforms/ShopMonitor'>Shop Monitor</a>
                    </li>
                    <li>
                        <a href='/Dashboard/TechPartner'>Tech Partner Dashboard</a>
                    </li>
                    <li>
                        <a href='/import/TechPartnerQuota' target={'_blank'}>
                            Tech Partner Quota Import
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    )
    // Test change to commit 4
}
